import React from "react";
import { useParams, redirect } from "react-router-dom";
import Login from "../templates/Login";
import TransitionWrapper from "../atoms/TransitionWrapper";
import UseLandingLoader from "../../hooks/useLandingLoader";
import { getAuthToken, removeAuthToken } from "../../utils/helper/token";

const LoginPage = () => {
  const params = useParams();
  UseLandingLoader();

  return (
    <TransitionWrapper>
      <Login portal={params.userType} />
    </TransitionWrapper>
  );
};

export default LoginPage;
